import { useEffect, useState } from "react";
import { Clock, User, Car } from "lucide-react";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import { PageHeader, StatusBadge } from "../components/Shared";
import { Input } from "../components/ui/input";

const today = () => new Date().toISOString().slice(0, 10);

export default function Schedule() {
  const { t, fmt } = useApp();
  const [date, setDate] = useState(today());
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/schedule", { params: { date } }).then((r) => setOrders(r.data)).catch(() => {});
  }, [date]);

  return (
    <div>
      <PageHeader title={t("schedule")}>
        <Input data-testid="schedule-date-input" type="date" value={date} onChange={(e) => setDate(e.target.value)}
          className="h-11 w-44 bg-white" />
      </PageHeader>
      {orders.length === 0 && (
        <div data-testid="schedule-empty" className="bg-white border border-slate-200 rounded-lg p-12 text-center text-slate-400">
          {t("noAppointments")}
        </div>
      )}
      <div className="space-y-3">
        {orders.map((o) => (
          <div key={o.id} data-testid={`schedule-item-${o.order_number}`}
            className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm flex flex-wrap items-center gap-x-8 gap-y-2">
            <div className="flex items-center gap-2 font-heading text-xl font-bold text-sky-600 w-20">
              <Clock size={18} /> {(o.scheduled_at || "").slice(11, 16) || "--:--"}
            </div>
            <div className="min-w-[180px]">
              <div className="font-semibold text-slate-900">{o.order_number} — {o.customer_name}</div>
              <div className="text-sm text-slate-500 flex items-center gap-1.5 uppercase">
                <Car size={13} /> {o.vehicle} {o.plate && `· ${o.plate}`}
              </div>
            </div>
            {o.technician && (
              <div className="text-sm text-slate-500 flex items-center gap-1.5">
                <User size={13} /> {o.technician}
              </div>
            )}
            <div className="font-medium">{fmt(o.total)}</div>
            {o.adas_type && (
              <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide ${
                o.adas_status === "completed" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>
                ADAS
              </span>
            )}
            <div className="ml-auto"><StatusBadge status={o.status} /></div>
          </div>
        ))}
      </div>
    </div>
  );
}
